import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js'

const url = gapi + "buses";


const buses = {
  namespaced: true,
  state: {
    busesAll: [],
    emps:[],              
    workarea:[],
    traffic:[] 
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.busesAll;
    },
    getTodoById: (state) => (id) => {
      return state.busesAll.find((todo) => todo.id == id);
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.busesAll = data;
    },

    ADD_DATA(state, data) {
      state.busesAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.busesAll.findIndex((t) => t.id === data.id);
   

      this.emps = str.state.emps.find((todo) => todo.id == data.ownerBus);
      this.workarea = str.state.workarea.find((todo) => todo.id == data.trafficFrom);
      this.traffic = str.state.traffic.find((todo) => todo.id == data.trafficTo);
      var dts = {
               id : data.id,
               busSeats: data.busSeats,
               boardNum: data.boardNum,
               lcStart: data.lcStart,
               lcEnd: data.lcEnd,
               busColor: data.busColor,
               busDate: data.busDate,
               busModel: data.busModel,
               busName: data.busName,
               ownerBus: data.ownerBus,
               trafficFrom: data.trafficFrom,
               trafficTo: data.trafficTo,
               contractNum: data.contractNum,
               Location: data.Location,
               vFrom: data.vFrom,
               vTo: data.vTo,
               emp: data.emp
              
                     }
      if (index !== -1) {
        state.busesAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.busesAll = state.busesAll.filter((t) => data.id !== t.id);
    },
  },
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
        })
        .catch((error) => console.log(error));
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
    async updateData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then(
          commit("UPDATE_DATA", data)

        )
        .catch((error) => console.log(error));
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default buses;
